import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from "@reduxjs/toolkit";
import { all } from "redux-saga/effects";
import { createLogger } from "redux-logger";
import { watchAuthUser } from "./auth/saga";
import authReducer from "./auth/slice";
import currentProject from "./project/slice";
import { watchsetProject } from "./project/saga";
import { watchCompany } from "./company/saga";
import companyReducer from "./company/slice";
import { watchsetOccupant } from "./occupant/saga";
import currentOccupant from "./occupant/slice";
import { watchsetRoles } from "./userRoles/saga";
import userRoles from "./userRoles/slice";
import occupantOption from "./occupantOption/slice";
import { watchsetOccupantOption } from "./occupantOption/saga";
import roleOptionData from "./roleOptions/slice";
import { watchRoleOptionsData } from "./roleOptions/saga";
import { watchCart } from "./cart/saga";
import cartData from "./cart/slice";
import { watchAccessControl } from "./accessControl/saga";
import  accessControlData from "./accessControl/slice";

const logger = createLogger({
  // ...options
});

// Root saga generator function
function* rootSaga() {
  yield all([
    watchAuthUser(),
    watchsetProject(),
    watchCompany(),
    watchsetOccupant(),
    watchsetRoles(),
    watchsetOccupantOption(),
    watchRoleOptionsData(),
    watchCart(),
    watchAccessControl()
  ]); // Add all the saga watchers here
}

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// middlewares
const middlewares = [];
middlewares.push(sagaMiddleware);
if (process.env.REACT_APP_ENVIRONMENT === "development")
  middlewares.push(logger);

// Configure the Redux store
const store = configureStore({
  reducer: {
    authdata: authReducer,
    currentProject: currentProject,
    currentOccupant: currentOccupant,
    companyData: companyReducer,
    userRoles: userRoles,
    occupantOption: occupantOption,
    roleOptionData: roleOptionData,
    cartData: cartData,
    accessControlData:accessControlData
  },
  devTools: true,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      thunk: false,
      immutableCheck: false,
      serializableCheck: false,
    }),
    ...middlewares,
  ],
});

// Run the root saga
sagaMiddleware.run(rootSaga);

export default store;
